import getSymbolFromCurrency from "currency-symbol-map";

export default class Util {
  static uniqueIdGenerator(name) {
    const strSplit = name.split(" ")[0][0];
    const uniqueNumber = Math.floor(Math.random() * 10000000000);
    return "".concat(strSplit, uniqueNumber);
  }

  static formatDate(date, changeFormat = false) {
    if (!date) return "";
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    if (changeFormat) {
      return [year, month, day].join("-");
    } else {
      return [day, month, year].join("/");
    }
  }

  static formatPrepaidCardFormDate(date) {
    if (!date) return "";
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("/");
  }

  static verifyEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  static verifyName(name) {
    const re = /^[a-zA-Z ]*$/;
    //const re = /[a-zA-Z][a-zA-Z ]/;
    //const re = /[a-zA-Z]/;
    return re.test(name);
  }

  static verifyAmount(amount) {
    const re = /^\d+(\.\d{0,2})?$/;
    return re.test(amount);
  }

  static verifyNumber(num) {
    const re = /^\d+$/g;
    return re.test(num);
  }

  static verifyDate(date) {
    const re = /^[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/;
    return re.test(date);
  }

  static verifyPassword(pwd) {
    const re =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^*!])(?=\S+$).{8,20}$/;
    return re.test(pwd);
  }

  static formatPhoneNumber(contact, code) {
    const reg = new RegExp(`\\+?s?${code}\\D+`);
    return contact.replace(reg, "").replace(/[^0-9]+/g, "");
  }

  static transactionsType() {
    return [
      { id: 1, name: "ALL" },
      { id: 2, name: "LOAD" },
      { id: 3, name: "SEND" },
      { id: 4, name: "PURCHASE" },
      { id: 5, name: "WITHDRAW" },
      { id: 6, name: "RECHARGE" },
      { id: 7, name: "RECEIVED" },
      { id: 8, name: "CARD LOAD" },
      { id: 9, name: "CASHOUT" },
      { id: 10, name: "PAYORDER" },
      { id: 11, name: "REFUND" },
      { id: 12, name: "CONVERSION" },
    ];
  }

  static shuffle(arr) {
    return arr.sort(() => Math.random() - 0.5);
  }

  static promoCodeGenerator() {
    const alphaNums = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789";
    let res = "";
    for (let i = 0; i < 8; i++) {
      const rnd = Math.floor(Math.random() * alphaNums.length);
      res = res + alphaNums.charAt(rnd);
    }
    return res;
  }

  static isImageUrl(url) {
    return /null$/.test(url);
  }

  static getFileName(url) {
    if (!url) return null;
    return url.match(/\w+.\w+$/g).join``;
  }

  static checkInputSpace(val) {
    return /^\s/.test(val);
  }

  static randomColor() {
    return (
      "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0")
    );
  }

  static discount(unitPrice, offerPrice, type) {
    if (!type) return null;
    return Number(
      type === "amount"
        ? unitPrice - offerPrice
        : unitPrice - (unitPrice * offerPrice) / 100
    ).toFixed(2);
  }

  static discountOff(type, currency, offerPrice) {
    return type === "amount"
      ? `${getSymbolFromCurrency(currency)} ${offerPrice} off`
      : `${offerPrice} % off`;
  }

  static getUboDirectorRange(isUbo, count) {
    return Array.from({ length: !isUbo ? +count + 1 : +count }).map((_, i) =>
      isUbo ? i + 1 : i
    );
  }
}
